import React from "react"
import { graphql } from "gatsby"
import PropTypes from "prop-types"

import { Title, Paragraph } from "components/atoms/Typography"
import Box from "components/atoms/Box"
import Button from "components/atoms/Button"

import { colors } from "utils/styled-constants"

const SectionText = ({
  title,
  subtitle,
  subtitleColor,
  subtitleFontStyle,
  variant,
  as,
  description,
  align,
  color,
  ...rest
}) => {
  return (
    <Box mx={align === "center" ? "auto" : ""} {...rest}>
      <Title
        mb={description ? 0 : "60px"}
        variant={variant}
        as="h2"
        textAlign={align}
        color={color}
      >
        {title}
      </Title>
      {subtitle && (
        <Paragraph
          fontStyle={subtitleFontStyle}
          mt={3}
          color={subtitleColor || colors.subtitleBlue}
        >
          {subtitle}
        </Paragraph>
      )}
      {description && (
        <Paragraph
          mt={"28px"}
          textAlign={align}
          color={color === "beige" ? "white" : color}
          markdown
          dangerouslySetInnerHTML={{
            __html: `<div> ${description.childMarkdownRemark.html} </div>`,
          }}
        />
      )}
    </Box>
  )
}

SectionText.propTypes = {
  title: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(["h1", "h2"]),
  as: PropTypes.oneOf(["h1", "h2"]),
  description: PropTypes.string,
  align: PropTypes.oneOf(["left", "center"]),
  color: PropTypes.oneOf(["white", "beige", "darkBlue", "mediumBlue"]),
  ...Box.propTypes,
  ...Button.propTypes,
}

SectionText.defaultProps = {
  color: "darkBlue",
  variant: "h2",
  align: "left",
}

export default SectionText

export const query = graphql`
  fragment SectionText on ContentfulSectionText {
    title
    description {
      childMarkdownRemark {
        html
      }
    }
    subtitle
    align
    color
  }
`
